/** 10軸の日本語名。API は英語キーを返すので、表示側だけで対応づける。 */
export const AXIS_LABELS: Record<string, string> = {
  life_stage: 'ライフステージ',
  purchase_purpose: '購買目的',
  purchase_behavior: '購買行動',
  information: '流入・情報取得',
  ltv: 'LTV',
  price_sensitivity: '価格感度',
  psychology: '心理状態',
  ai_understanding: 'AI理解',
  channel: 'チャネル',
  engagement: 'エンゲージメント'
}
